import { SiteIntegration } from '@/features/settings'
import './siteIntegrationWidget.scss'

export type SiteIntegrationWidgetProps = {
    siteId: number
}
export const SiteIntegrationWidget = ({
    siteId,
}: SiteIntegrationWidgetProps) => {
    return (
        <div className="site-integration-widget">
            <h3 className="site-integration-title">Интеграция с сайтом</h3>
            <SiteIntegration siteId={siteId} />
        </div>
    )
}
